import { getApiV2Client } from '@mi-front/api-v2';

const API_V2_ROOT =
  import.meta.env.VITE_API_V2_ROOT ??
  (import.meta.env.VITE_ENV?.startsWith('prod')
    ? 'https://api.mediainbox.io'
    : 'https://api-dev.mediainbox.io');

/**
 * Builds a signed GET URL for a web-app BFF path on the unified API host.
 */
export function generateWebAppSignedUrl(
  path: string,
  params?: Record<string, string | boolean | number>,
): string {
  return getApiV2Client().generateUrl(`${API_V2_ROOT}${path}`, {
    prependBaseURL: false,
    secure: true,
    params,
  });
}
